import type { LocaleId } from './locale';

export type MessageTable = Record<string, string>;

const EN: MessageTable = {
  'entity.starter_ride': 'Starter Ride',
  'entity.spinning_ride': 'Spinning Ride',
  'entity.pirate_ship': 'Pirate Ship',
  'entity.ferris_wheel': 'Ferris Wheel',
  'entity.roller_coaster': 'Roller Coaster',
  'entity.snack_kiosk': 'Snack Kiosk',
  'entity.drink_kiosk': 'Drink Kiosk',
  'entity.bench': 'Bench',
  'entity.tree': 'Tree',
  'entity.lamp': 'Lamp',
  'parcel.parcel_start': 'Park',
  'parcel.parcel_east': 'East lawn',
  'parcel.parcel_north': 'North ridge',
  'hud.coins': 'Coins {n}',
  'hud.park': 'Park {n}',
  'hud.build': 'Build',
  'hud.done': 'Done',
  'hud.placeHere': 'Place here',
  'hud.collectAll': 'Collect All',
  'hud.land': 'Land',
  'hud.floor': 'Floor',
  'hud.sound': 'Sound',
  'hud.boost': 'Boost',
  'hud.muted': 'Muted',
  'hud.reset': 'Reset save',
  'hud.close': 'Close',
  'hud.collapse': 'Collapse',
  'hud.expandPanel': 'Show',
  'hud.classic': 'Classic',
  'hud.brick': 'Brick',
  'hud.stone': 'Stone',
  'hud.kidsTile': 'Kids tile',
  'hud.wood': 'Boardwalk',
  'hud.festive': 'Festive',
  'hud.flowerPink': 'Pink flowers',
  'hud.flowerYellow': 'Yellow flowers',
  'hud.flowerMix': 'Mixed flowers',
  'hud.clover': 'Clover',
  'hud.garden': 'Garden carpet',
  'hud.erase': 'Erase',
  'hud.floorPaths': 'Paths',
  'hud.floorFlowers': 'Flowers',
  'hud.floorCost': '{n}',
  'hud.floorFree': 'Free',
  'hud.viewLeft': 'View left',
  'hud.viewRight': 'View right',
  'hud.zoomIn': 'Zoom in',
  'hud.zoomOut': 'Zoom out',
  'hud.language': 'Language',
  'action.collect': 'Collect',
  'action.collectN': 'Collect {n}',
  'action.upgrade': 'Upgrade · {n}',
  'action.move': 'Move',
  'action.rotate': 'Rotate',
  'action.remove': 'Remove',
  'action.confirmRemove': 'Confirm remove',
  'action.cancel': 'Cancel',
  'action.cancelMove': 'Cancel move',
  'action.buyLand': 'Buy land · {n}',
  'action.findLand': 'Find land',
  'action.continue': 'Continue',
  'action.watchAdBuild': 'Watch ad for 25% off next attraction',
  'action.watchAdLand': 'Watch ad for 25% off this land',
  'action.watchAdAutoCollect': 'Watch ad for Auto Collect 10m',
  'action.watchAdOffline2x': 'Watch ad → 2x',
  'land.coins': '{n} coins',
  'land.eastMilestone': 'East milestone {have}/{need}',
  'land.northMilestone': 'North milestone {have}/{need}',
  'land.advancesFerris': 'Unlocks Ferris Wheel — place it anywhere it fits',
  'land.advancesCoaster': 'Unlocks Roller Coaster — place it anywhere it fits',
  'land.recommended': 'Recommended',
  'toast.findLandAdvance': 'This land unlocks {name}. Then place it anywhere it fits.',
  'section.place': 'Place',
  'section.colors': 'Colors',
  'note.stored': 'Stored {n} / {cap}',
  'note.decoration': 'Decoration. Adds park score.',
  'note.maxLevel': 'Max level for this greybox.',
  'note.dragPlace': 'Drag to a valid highlighted space.',
  'note.removeRefund': 'Remove refunds {n} coins (base build cost only).',
  'note.kioskCap': 'Kiosks {used}/{capacity}',
  'note.kioskCapFirst': 'Build a ride to unlock 2 kiosk slots',
  'note.kioskCapGrow': 'A new attraction type adds +1 capacity',
  'note.kioskCapFinal': 'Shared kiosk limit reached',
  'note.starterGate': 'Build your first ride first',
  'title.entity': '{name} · Lv {level}',
  'title.build': 'Build on {slot}',
  'title.buildHere': 'Build here',
  'title.place': 'Place {name}',
  'title.lockedLand': 'Locked land',
  'title.boosts': 'Boosts',
  'title.welcomeBack': 'Welcome back',
  'goal.next': 'Next: {name}',
  'goal.coasterBuilt': 'Coaster built',
  'goal.keepGrowing': 'Keep growing the park',
  'goal.need': 'Need {name}',
  'goal.unlock': 'Unlock {name} · {have}/{cost} coins',
  'goal.parkScore': 'Park {have}/{need}',
  'goal.coins': '{have}/{cost} coins',
  'goal.ready': 'Ready · {cost} coins',
  'goal.action': '{name} · {have}/{cost}',
  'goal.upgrade': 'Upgrade {name} · {have}/{cost}',
  'goal.ferris': '{name} · {cost} · {gap} to go',
  'guide.buildRide': 'Build your first ride',
  'guide.buildSnack': 'Add a Snack Kiosk',
  'guide.collectDrink': 'Collect coins for a Drink Kiosk · {have}/{cost}',
  'guide.buildDrink': 'Add a Drink Kiosk',
  'guide.complete': 'Great! Your park is open — build it your way.',
  'guide.completeReward': 'Great! Your park is open · +{n}',
  'fail.unknown_slot': 'That space is missing.',
  'fail.unknown_kind': 'Unknown item.',
  'fail.locked': 'Unlock this land first.',
  'fail.locked_item': 'That item is still locked.',
  'fail.occupied': 'This space is already used.',
  'fail.empty': 'Nothing is here.',
  'fail.cannot_afford': 'Not enough coins.',
  'fail.max_level': 'Already at max level.',
  'fail.not_upgradable': 'This cannot be upgraded.',
  'fail.already_unlocked': 'This land is already unlocked.',
  'fail.unknown_parcel': 'Unknown land parcel.',
  'fail.parcel_prereq': 'Unlock the previous land first.',
  'fail.no_income': 'Nothing to collect yet.',
  'fail.income_reserve': 'Keep coins for an income ride.',
  'fail.kiosk_capacity': 'Shared kiosk limit reached.',
  'fail.starter_gate': 'Build your first ride first.',
  'fail.generic': 'Cannot do that.',
  'toast.rotated': 'Rotated',
  'toast.moved': 'Moved',
  'toast.cancelled': 'Placement cancelled',
  'toast.dragRotate': 'Drag to place. Rotate updates the preview.',
  'toast.dragCharge': 'Drag to place. Coins charge only on confirm.',
  'toast.removed': 'Removed · refund {n}',
  'toast.welcomeBack': 'Welcome back! +{n} coins earned while away.',
  'toast.built': 'Built {name}',
  'toast.upgraded': 'Upgraded',
  'toast.landUnlocked': 'Land unlocked',
  'toast.useLand': 'Locked land — use Land',
  'rewarded.discounted': '25% off · {n}',
  'rewarded.buildCouponActive': '25% off next attraction',
  'rewarded.landVoucherActive': '25% off this land',
  'rewarded.autoCollectReady': 'Auto Collect 10m',
  'rewarded.autoCollectActive': 'Auto Collect {n}',
  'rewarded.welcomeBack': 'Welcome back! +{n} coins already collected.',
  'rewarded.unavailable': 'Ad unavailable. Try again later.',
  'rewarded.cooldown': 'Available in {n}s',
  'rewarded.watching': 'Watching ad…',
  'palette.candyStripe': 'Candy',
  'palette.skyFair': 'Sky',
  'palette.mintParade': 'Mint',
  'palette.classicRed': 'Classic',
  'palette.oceanBlue': 'Ocean',
  'palette.sunsetGold': 'Sunset',
};

const PT: MessageTable = {
  ...EN,
  'entity.starter_ride': 'Brinquedo inicial',
  'entity.spinning_ride': 'Xícaras',
  'entity.pirate_ship': 'Barco pirata',
  'entity.ferris_wheel': 'Roda-gigante',
  'entity.roller_coaster': 'Montanha-russa',
  'entity.snack_kiosk': 'Quiosque de lanches',
  'entity.drink_kiosk': 'Quiosque de bebidas',
  'entity.bench': 'Banco',
  'entity.tree': 'Árvore',
  'entity.lamp': 'Lâmpada',
  'parcel.parcel_start': 'Parque',
  'parcel.parcel_east': 'Gramado leste',
  'parcel.parcel_north': 'Morro norte',
  'hud.coins': 'Moedas {n}',
  'hud.park': 'Parque {n}',
  'hud.build': 'Construir',
  'hud.done': 'Pronto',
  'hud.placeHere': 'Colocar aqui',
  'hud.collectAll': 'Coletar tudo',
  'hud.land': 'Terreno',
  'hud.floor': 'Piso',
  'hud.sound': 'Som',
  'hud.boost': 'Boost',
  'hud.muted': 'Mudo',
  'hud.reset': 'Resetar save',
  'hud.close': 'Fechar',
  'hud.collapse': 'Recolher',
  'hud.expandPanel': 'Mostrar',
  'hud.classic': 'Clássico',
  'hud.brick': 'Tijolo',
  'hud.stone': 'Pedra',
  'hud.kidsTile': 'Ladrilho kids',
  'hud.wood': 'Deck',
  'hud.festive': 'Festivo',
  'hud.flowerPink': 'Flores rosa',
  'hud.flowerYellow': 'Flores amarelas',
  'hud.flowerMix': 'Flores mistas',
  'hud.clover': 'Trevo',
  'hud.garden': 'Jardim',
  'hud.erase': 'Apagar',
  'hud.floorPaths': 'Caminhos',
  'hud.floorFlowers': 'Flores',
  'hud.floorCost': '{n}',
  'hud.floorFree': 'Grátis',
  'hud.viewLeft': 'Ver esquerda',
  'hud.viewRight': 'Ver direita',
  'hud.zoomIn': 'Aproximar',
  'hud.zoomOut': 'Afastar',
  'hud.language': 'Idioma',
  'action.collect': 'Coletar',
  'action.collectN': 'Coletar {n}',
  'action.upgrade': 'Melhorar · {n}',
  'action.move': 'Mover',
  'action.rotate': 'Girar',
  'action.remove': 'Remover',
  'action.confirmRemove': 'Confirmar remoção',
  'action.cancel': 'Cancelar',
  'action.cancelMove': 'Cancelar movimento',
  'action.buyLand': 'Comprar terreno · {n}',
  'action.findLand': 'Encontrar terreno',
  'action.continue': 'Continuar',
  'action.watchAdBuild': 'Assistir anúncio: 25% off na próxima atração',
  'action.watchAdLand': 'Assistir anúncio: 25% off neste terreno',
  'action.watchAdAutoCollect': 'Assistir anúncio: coleta automática 10 min',
  'action.watchAdOffline2x': 'Assistir anúncio → 2x',
  'land.coins': '{n} moedas',
  'land.eastMilestone': 'Marco leste {have}/{need}',
  'land.northMilestone': 'Marco norte {have}/{need}',
  'land.advancesFerris': 'Libera a Roda-gigante — coloque onde couber',
  'land.advancesCoaster': 'Libera a Montanha-russa — coloque onde couber',
  'land.recommended': 'Recomendado',
  'toast.findLandAdvance': 'Este terreno libera {name}. Depois coloque onde couber.',
  'section.place': 'Posição',
  'section.colors': 'Cores',
  'note.stored': 'Guardado {n} / {cap}',
  'note.decoration': 'Decoração. Soma pontuação do parque.',
  'note.maxLevel': 'Nível máximo neste greybox.',
  'note.dragPlace': 'Arraste para um espaço válido destacado.',
  'note.removeRefund': 'Remover devolve {n} moedas (só o custo base).',
  'note.kioskCap': 'Quiosques {used}/{capacity}',
  'note.kioskCapFirst': 'Construa um brinquedo para liberar 2 quiosques',
  'note.kioskCapGrow': 'Um novo tipo de atração aumenta a capacidade em +1',
  'note.kioskCapFinal': 'Limite compartilhado de quiosques atingido',
  'note.starterGate': 'Construa o primeiro brinquedo primeiro',
  'title.entity': '{name} · Nv {level}',
  'title.build': 'Construir em {slot}',
  'title.buildHere': 'Construir aqui',
  'title.place': 'Posicionar {name}',
  'title.lockedLand': 'Terreno bloqueado',
  'title.boosts': 'Boosts',
  'title.welcomeBack': 'Bem-vindo de volta',
  'goal.next': 'Próximo: {name}',
  'goal.coasterBuilt': 'Montanha-russa construída',
  'goal.keepGrowing': 'Continue expandindo o parque',
  'goal.need': 'Precisa de {name}',
  'goal.unlock': 'Liberar {name} · {have}/{cost} moedas',
  'goal.parkScore': 'Parque {have}/{need}',
  'goal.coins': '{have}/{cost} moedas',
  'goal.ready': 'Pronto · {cost} moedas',
  'goal.action': '{name} · {have}/{cost}',
  'goal.upgrade': 'Melhore {name} · {have}/{cost}',
  'goal.ferris': '{name} · {cost} · faltam {gap}',
  'guide.buildRide': 'Construa seu primeiro brinquedo',
  'guide.buildSnack': 'Adicione um quiosque de lanches',
  'guide.collectDrink': 'Junte moedas para um quiosque de bebidas · {have}/{cost}',
  'guide.buildDrink': 'Adicione um quiosque de bebidas',
  'guide.complete': 'Ótimo! Seu parque está aberto — construa do seu jeito.',
  'guide.completeReward': 'Ótimo! Seu parque está aberto · +{n}',
  'fail.unknown_slot': 'Esse espaço não existe.',
  'fail.unknown_kind': 'Item desconhecido.',
  'fail.locked': 'Liberte este terreno primeiro.',
  'fail.locked_item': 'Esse item ainda está bloqueado.',
  'fail.occupied': 'Este espaço já está em uso.',
  'fail.empty': 'Não há nada aqui.',
  'fail.cannot_afford': 'Moedas insuficientes.',
  'fail.max_level': 'Já está no nível máximo.',
  'fail.not_upgradable': 'Isto não pode ser melhorado.',
  'fail.already_unlocked': 'Este terreno já está liberado.',
  'fail.unknown_parcel': 'Terreno desconhecido.',
  'fail.parcel_prereq': 'Liberte o terreno anterior primeiro.',
  'fail.no_income': 'Nada para coletar ainda.',
  'fail.income_reserve': 'Guarde moedas para um brinquedo de renda.',
  'fail.kiosk_capacity': 'Limite compartilhado de quiosques atingido.',
  'fail.starter_gate': 'Construa o primeiro brinquedo primeiro.',
  'fail.generic': 'Não é possível fazer isso.',
  'toast.rotated': 'Girado',
  'toast.moved': 'Movido',
  'toast.cancelled': 'Posicionamento cancelado',
  'toast.dragRotate': 'Arraste para posicionar. Girar atualiza a prévia.',
  'toast.dragCharge': 'Arraste para posicionar. Moedas só saem na confirmação.',
  'toast.removed': 'Removido · reembolso {n}',
  'toast.welcomeBack': 'Bem-vindo de volta! +{n} moedas enquanto estava ausente.',
  'toast.built': 'Construído: {name}',
  'toast.upgraded': 'Melhorado',
  'toast.landUnlocked': 'Terreno liberado',
  'toast.useLand': 'Terreno bloqueado — use Terreno',
  'rewarded.discounted': '25% off · {n}',
  'rewarded.buildCouponActive': '25% off na próxima atração',
  'rewarded.landVoucherActive': '25% off neste terreno',
  'rewarded.autoCollectReady': 'Coleta automática 10 min',
  'rewarded.autoCollectActive': 'Coleta automática {n}',
  'rewarded.welcomeBack': 'Bem-vindo de volta! +{n} moedas já coletadas.',
  'rewarded.unavailable': 'Anúncio indisponível. Tente mais tarde.',
  'rewarded.cooldown': 'Disponível em {n}s',
  'rewarded.watching': 'Assistindo anúncio…',
  'palette.candyStripe': 'Doce',
  'palette.skyFair': 'Céu',
  'palette.mintParade': 'Menta',
  'palette.classicRed': 'Clássico',
  'palette.oceanBlue': 'Oceano',
  'palette.sunsetGold': 'Pôr do sol',
};

const ES: MessageTable = {
  ...EN,
  'entity.starter_ride': 'Atracción inicial',
  'entity.spinning_ride': 'Tazas giratorias',
  'entity.pirate_ship': 'Barco pirata',
  'entity.ferris_wheel': 'Noria',
  'entity.roller_coaster': 'Montaña rusa',
  'entity.snack_kiosk': 'Puesto de snacks',
  'entity.drink_kiosk': 'Puesto de bebidas',
  'entity.bench': 'Banco',
  'entity.tree': 'Árbol',
  'entity.lamp': 'Farola',
  'parcel.parcel_start': 'Parque',
  'parcel.parcel_east': 'Césped este',
  'parcel.parcel_north': 'Cresta norte',
  'hud.coins': 'Monedas {n}',
  'hud.park': 'Parque {n}',
  'hud.build': 'Construir',
  'hud.done': 'Listo',
  'hud.placeHere': 'Colocar aquí',
  'hud.collectAll': 'Recoger todo',
  'hud.land': 'Terreno',
  'hud.floor': 'Suelo',
  'hud.sound': 'Sonido',
  'hud.boost': 'Boost',
  'hud.muted': 'Silencio',
  'hud.reset': 'Reiniciar save',
  'hud.close': 'Cerrar',
  'hud.collapse': 'Contraer',
  'hud.expandPanel': 'Mostrar',
  'hud.classic': 'Clásico',
  'hud.brick': 'Ladrillo',
  'hud.stone': 'Piedra',
  'hud.kidsTile': 'Baldosa infantil',
  'hud.wood': 'Entarimado',
  'hud.festive': 'Festivo',
  'hud.flowerPink': 'Flores rosas',
  'hud.flowerYellow': 'Flores amarillas',
  'hud.flowerMix': 'Flores mixtas',
  'hud.clover': 'Trébol',
  'hud.garden': 'Jardín',
  'hud.erase': 'Borrar',
  'hud.floorPaths': 'Caminos',
  'hud.floorFlowers': 'Flores',
  'hud.floorCost': '{n}',
  'hud.floorFree': 'Gratis',
  'hud.viewLeft': 'Ver izquierda',
  'hud.viewRight': 'Ver derecha',
  'hud.zoomIn': 'Acercar',
  'hud.zoomOut': 'Alejar',
  'hud.language': 'Idioma',
  'action.collect': 'Recoger',
  'action.collectN': 'Recoger {n}',
  'action.upgrade': 'Mejorar · {n}',
  'action.move': 'Mover',
  'action.rotate': 'Girar',
  'action.remove': 'Quitar',
  'action.confirmRemove': 'Confirmar quitar',
  'action.cancel': 'Cancelar',
  'action.cancelMove': 'Cancelar movimiento',
  'action.buyLand': 'Comprar terreno · {n}',
  'action.findLand': 'Buscar terreno',
  'action.continue': 'Continuar',
  'action.watchAdBuild': 'Ver anuncio: 25% off en la próxima atracción',
  'action.watchAdLand': 'Ver anuncio: 25% off en este terreno',
  'action.watchAdAutoCollect': 'Ver anuncio: recolección automática 10 min',
  'action.watchAdOffline2x': 'Ver anuncio → 2x',
  'land.coins': '{n} monedas',
  'land.eastMilestone': 'Hito este {have}/{need}',
  'land.northMilestone': 'Hito norte {have}/{need}',
  'land.advancesFerris': 'Desbloquea la Noria — colócala donde quepa',
  'land.advancesCoaster': 'Desbloquea la Montaña rusa — colócala donde quepa',
  'land.recommended': 'Recomendado',
  'toast.findLandAdvance': 'Esta tierra desbloquea {name}. Luego colócalo donde quepa.',
  'section.place': 'Colocar',
  'section.colors': 'Colores',
  'note.stored': 'Guardado {n} / {cap}',
  'note.decoration': 'Decoración. Suma puntuación del parque.',
  'note.maxLevel': 'Nivel máximo en este greybox.',
  'note.dragPlace': 'Arrastra a un espacio válido resaltado.',
  'note.removeRefund': 'Quitar devuelve {n} monedas (solo el coste base).',
  'note.kioskCap': 'Puestos {used}/{capacity}',
  'note.kioskCapFirst': 'Construye una atracción para desbloquear 2 puestos',
  'note.kioskCapGrow': 'Un nuevo tipo de atracción suma +1 de capacidad',
  'note.kioskCapFinal': 'Límite compartido de puestos alcanzado',
  'note.starterGate': 'Construye tu primera atracción primero',
  'title.entity': '{name} · Nv {level}',
  'title.build': 'Construir en {slot}',
  'title.buildHere': 'Construir aquí',
  'title.place': 'Colocar {name}',
  'title.lockedLand': 'Terreno bloqueado',
  'title.boosts': 'Boosts',
  'title.welcomeBack': 'Bienvenido de nuevo',
  'goal.next': 'Siguiente: {name}',
  'goal.coasterBuilt': 'Montaña rusa construida',
  'goal.keepGrowing': 'Sigue ampliando el parque',
  'goal.need': 'Necesitas {name}',
  'goal.unlock': 'Liberar {name} · {have}/{cost} monedas',
  'goal.parkScore': 'Parque {have}/{need}',
  'goal.coins': '{have}/{cost} monedas',
  'goal.ready': 'Listo · {cost} monedas',
  'goal.action': '{name} · {have}/{cost}',
  'goal.upgrade': 'Mejora {name} · {have}/{cost}',
  'goal.ferris': '{name} · {cost} · faltan {gap}',
  'guide.buildRide': 'Construye tu primera atracción',
  'guide.buildSnack': 'Añade un puesto de snacks',
  'guide.collectDrink': 'Junta monedas para un puesto de bebidas · {have}/{cost}',
  'guide.buildDrink': 'Añade un puesto de bebidas',
  'guide.complete': '¡Genial! Tu parque está abierto — constrúyelo a tu manera.',
  'guide.completeReward': '¡Genial! Tu parque está abierto · +{n}',
  'fail.unknown_slot': 'Ese espacio no existe.',
  'fail.unknown_kind': 'Objeto desconocido.',
  'fail.locked': 'Libera este terreno primero.',
  'fail.locked_item': 'Ese objeto sigue bloqueado.',
  'fail.occupied': 'Este espacio ya está en uso.',
  'fail.empty': 'No hay nada aquí.',
  'fail.cannot_afford': 'No hay suficientes monedas.',
  'fail.max_level': 'Ya está al nivel máximo.',
  'fail.not_upgradable': 'Esto no se puede mejorar.',
  'fail.already_unlocked': 'Este terreno ya está liberado.',
  'fail.unknown_parcel': 'Parcela desconocida.',
  'fail.parcel_prereq': 'Libera el terreno anterior primero.',
  'fail.no_income': 'Aún no hay nada que recoger.',
  'fail.income_reserve': 'Guarda monedas para una atracción de ingresos.',
  'fail.kiosk_capacity': 'Límite compartido de puestos alcanzado.',
  'fail.starter_gate': 'Construye tu primera atracción primero.',
  'fail.generic': 'No se puede hacer eso.',
  'toast.rotated': 'Girado',
  'toast.moved': 'Movido',
  'toast.cancelled': 'Colocación cancelada',
  'toast.dragRotate': 'Arrastra para colocar. Girar actualiza la vista previa.',
  'toast.dragCharge': 'Arrastra para colocar. Las monedas solo se cobran al confirmar.',
  'toast.removed': 'Quitado · reembolso {n}',
  'toast.welcomeBack': '¡Bienvenido de nuevo! +{n} monedas mientras estabas ausente.',
  'toast.built': 'Construido: {name}',
  'toast.upgraded': 'Mejorado',
  'toast.landUnlocked': 'Terreno liberado',
  'toast.useLand': 'Terreno bloqueado — usa Terreno',
  'rewarded.discounted': '25% off · {n}',
  'rewarded.buildCouponActive': '25% off en la próxima atracción',
  'rewarded.landVoucherActive': '25% off en este terreno',
  'rewarded.autoCollectReady': 'Recolección automática 10 min',
  'rewarded.autoCollectActive': 'Recolección automática {n}',
  'rewarded.welcomeBack': '¡Bienvenido de nuevo! +{n} monedas ya recogidas.',
  'rewarded.unavailable': 'Anuncio no disponible. Inténtalo más tarde.',
  'rewarded.cooldown': 'Disponible en {n}s',
  'rewarded.watching': 'Viendo anuncio…',
  'palette.candyStripe': 'Dulce',
  'palette.skyFair': 'Cielo',
  'palette.mintParade': 'Menta',
  'palette.classicRed': 'Clásico',
  'palette.oceanBlue': 'Océano',
  'palette.sunsetGold': 'Atardecer',
};

export const STRINGS: Record<LocaleId, MessageTable> = {
  en: EN,
  'pt-BR': PT,
  es: ES,
};
